export const RESET_LOGS = 'RESET_LOGS'
export const SET_LOGS = 'SET_LOGS'
